import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import React, { useState } from 'react'

import { IconButton } from 'slab'
import type { MembersEnrollment } from 'utils/web_api.schemas'

import EnrollmentDetails from './EnrollmentDetails/EnrollmentDetails'

interface EnrollmentsCarouselProps {
  enrollments: MembersEnrollment[] | undefined,
  isPriorYear: boolean
  showNavigation: boolean
  setShowHeader?: (show: boolean) => void
}

const EnrollmentsCarousel: React.FC<EnrollmentsCarouselProps> = ({
  enrollments,
  isPriorYear,
  showNavigation,
  setShowHeader,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  // Reset to first enrollment when enrollments change
  React.useEffect(() => {
    setCurrentIndex(0)
  }, [enrollments])

  if (!enrollments || enrollments.length === 0) {
    return null
  }

  const canGoBack = currentIndex > 0
  const canGoForward = currentIndex < enrollments.length - 1

  const handlePrevious = () => {
    setCurrentIndex(prev => Math.max(0, prev - 1))
  }

  const handleNext = () => {
    setCurrentIndex(prev => Math.min(enrollments.length - 1, prev + 1))
  }

  return (
    <>
      {showNavigation && (
        <>
          <div className='w-full body-sm text-gray-500'>You had multiple plans for this year due to qualifying life events</div>
          <div className='w-full flex flex-row justify-start items-center gap-4'>
            <IconButton
              icon={ChevronLeftIcon}
              label='View previous plan'
              onClick={handlePrevious}
              disabled={!canGoBack}
              style={{ opacity: canGoBack ? 1 : 0.3 }}
            />
            <span className='body-sm-bold text-main'>{currentIndex + 1} of {enrollments.length} plans</span>
            <IconButton
              icon={ChevronRightIcon}
              label='View next plan'
              onClick={handleNext}
              disabled={!canGoForward}
              style={{ opacity: canGoForward ? 1 : 0.3 }}
            />
          </div>
        </>
      )}
      <EnrollmentDetails
        enrollment={enrollments[currentIndex]}
        isPriorYear={isPriorYear}
        setShowHeader={setShowHeader}
      />
    </>
  )
}

export default EnrollmentsCarousel
